import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import AdminPanel from './components/AdminPanel';
import PrivacyPolicy from './components/PrivacyPolicy';
import { ContentProvider } from './contexts/ContentContext';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <ContentProvider>
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                className="min-h-screen bg-[#F8F3F0]"
              >
                <Navbar isScrolled={isScrolled} />
                <main className="scroll-smooth">
                  <Hero />
                  <About />
                  <Services />
                  <Contact />
                  <Footer />
                </main>
              </motion.div>
            }
          />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/politica-de-privacidade" element={<PrivacyPolicy />} />
        </Routes>
      </Router>
    </ContentProvider>
  );
}

export default App;
